<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="editTripform">
  <div class="accordion-class">
    <h5>Retail Quote Edit Trip</h5>
    <mat-divider></mat-divider>
  </div>
  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Trip ID </mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="trip_id" required readonly />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Customer ID</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="user_id" required readonly />
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Customer Name</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="username" required readonly />
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Customer Mobile</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="mobile" required readonly />
          </mat-form-field>
        </div>
      </div>

      <mat-divider class="divider_mat"></mat-divider>
      <div class="row mtb align-items-center">
        <div class="col-md-12">
          <h6>Trip Details</h6>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Price</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input type="number" matInput formControlName="price" />
            <mat-error>Please Enter Price Per Ton</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Vehicle No</mat-label>
        </div>
        <div class="col-sm-3">
          <mat-form-field
            class="flex-gt-sm example-full-width truck-type-input"
          >
            <mat-select
              dropLocationSearchField
              formControlName="truck_number"
              (selectionChange)="getVehiclesList($event)"
              required
            >
              <mat-option
                *ngFor="let truck of truckArray"
                value="{{ truck._id }}"
              >
                {{ truck.truck_number }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Driver Name</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="driver_id" required readonly />
            <mat-error>Please Enter Driver Name</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Driver Number</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input matInput formControlName="driver_number" required readonly />
            <mat-error>Please Enter Driver No</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Truck Owner Name</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input
              type="text"
              matInput
              formControlName="truck_ownerName"
              required
              readonly
            />
            <mat-error>Please Enter Truck Owner Name </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-3">
          <mat-label>Truck Owner No</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <input
              matInput
              formControlName="truck_ownerNumber"
              required
              readonly
            />
            <mat-error>Please Enter Truck Owner No</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb align-items-center">
        <div class="col-md-3">
          <mat-label>Pickup Date</mat-label>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-datepicker #picker></mat-datepicker>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="DD-MM-YYYY"
              [min]="minDate"
              formControlName="trip_booking_date"
              (click)="picker.open()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-7">
    <button
      type="submit"
      [class.spinner]="loading"
      [disabled]="loading"
      class="button buttonBlue"
      (click)="UpdateTrips()"
    >
      Submit
    </button>
  </div>
</form>
